import { render, staticRenderFns } from "./SelectionComponent.vue?vue&type=template&id=1b234869&scoped=true&"
import script from "./SelectionComponent.vue?vue&type=script&lang=js&"
export * from "./SelectionComponent.vue?vue&type=script&lang=js&"
import style0 from "./SelectionComponent.vue?vue&type=style&index=0&id=1b234869&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b234869",
  null
  
)

export default component.exports